import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FeatureFlag } from '@app/enums';
import { PayrollModuleMenuService } from '@app/modules/payroll/services/payroll-module-menu.service';
import { AuthService, NotifyService } from '@app/services';
import { FeatureService } from '@app/services/feature.service';
import { T4Summary } from '@models/payroll/t4-summary.model';
import { EmployerPackageTable, T4Service } from '@payroll/services';

const FIRST_TAX_YEAR_AVAILABLE = 2017;

@Component({
    selector: 'app-tax-form-overview',
    templateUrl: './tax-form-overview.template.html',
})
export class TaxFormOverview {
    isLoading = false;

    selectedYear: number;

    taxFormYears: number[] = [];
    craBusinessNumber: string = this.auth.company.craBusinessNumber;

    employerPackageTable: EmployerPackageTable;

    enableT4ForTaxYear = false;

    currentTaxSeason: number;

    constructor(
        public auth: AuthService,
        private notify: NotifyService,
        private router: Router,
        private route: ActivatedRoute,
        private featureService: FeatureService,
        private t4Service: T4Service,
        public payrollModuleMenuService: PayrollModuleMenuService
    ) {
        this.currentTaxSeason = new Date().getFullYear() - 1;
        this.taxFormYears = this.getYearsArraySince(FIRST_TAX_YEAR_AVAILABLE);

        this.selectedYear = +this.route.snapshot.params.year || new Date().getFullYear() - 1;

        this.employerPackageTable = new EmployerPackageTable(this.auth, this.selectedYear);
        this.featureService.has(FeatureFlag.enableT4ForTaxYear).then((enableT4ForTaxYear) => {
            this.enableT4ForTaxYear = enableT4ForTaxYear;
        });
    }

    async generateT4s(year: number): Promise<void> {
        this.isLoading = true;
        try {
            await this.t4Service.generateT4Summary(new T4Summary({ year }));
            this.employerPackageTable.reload();
            this.isLoading = false;
        } catch (e) {
            this.notify.error(e);
            this.isLoading = false;
        }
    }

    getYearsArraySince(startYear: number): number[] {
        const years = [];

        startYear = startYear || 1980;
        while (startYear <= this.currentTaxSeason) {
            startYear += 1;
            years.push(startYear);
        }
        return years;
    }

    onYearChange(): void {
        this.router.navigate(['/payroll/records/tax-forms', this.selectedYear]);
    }
}
